import { createAction, props } from '@ngrx/store';
import { OrderFilters } from '@shared/models/order-filters';

export const setOrderFilters = createAction(
  '[Orders] Set Order Filters',
  props<{ filters: OrderFilters | undefined }>(),
);
